import axios, { AxiosResponse } from "axios";
import { createApiHeaders } from "../../../modules/auth/utils/api-headers";

const API_URL_DISBURSE = process.env.REACT_APP_DISBURSEMENT_API_URL;
const GET_MERCHANT_URL = `${API_URL_DISBURSE}/merchant`;

const getMerchants = (params: any) => {
  return axios
    .get(`${GET_MERCHANT_URL}/account-profile`, {
      params: {
        ...params.paging,
        merchantName: params.merchantName,
      },
      headers: {
        ...createApiHeaders(),
      },
      withCredentials: true,
    })
    .then((response: AxiosResponse<any>) => response.data);
};

const getMerchant = async (params: any) => {
  return axios
    .get(`${GET_MERCHANT_URL}/account-profile/${params.id}`, {
      headers: {
        ...createApiHeaders(),
      },
      withCredentials: true,
    })
    .then((response: AxiosResponse<any>) => response.data);
};

const createMerchant = async (params: any) => {
  const payload = {
    ...params.businessInfo,
    picInfo: { ...params.picInfo },
    additionalData: params.additionalData,
  };
  return axios
    .post(`${GET_MERCHANT_URL}/account-profile`, payload, {
      headers: {
        ...createApiHeaders(),
      },
      withCredentials: true,
    })
    .then((response: AxiosResponse<any>) => response.data);
};

const deleteMerchant = async (params: any) => {
  return axios
    .delete(`${GET_MERCHANT_URL}/account-profile/${params.id}`, {
      headers: {
        ...createApiHeaders(),
      },
      withCredentials: true,
    })
    .then((response: AxiosResponse<any>) => response.data);
};

const editMerchant = async (params: any) => {
  const payload = {
    ...params.businessInfo,
    picInfo: { ...params.picInfo },
    additionalData: params.additionalData,
  };
  return axios
    .put(`${GET_MERCHANT_URL}/account-profile/${params._id}`, payload, {
      headers: {
        ...createApiHeaders(),
      },
      withCredentials: true,
    })
    .then((response: AxiosResponse<any>) => response.data);
};
export {
  getMerchants,
  createMerchant,
  getMerchant,
  deleteMerchant,
  editMerchant,
};
